import { render, staticRenderFns } from "./ocrInput.vue?vue&type=template&id=0d866349&scoped=true&"
import script from "./ocrInput.vue?vue&type=script&lang=js&"
export * from "./ocrInput.vue?vue&type=script&lang=js&"
import style0 from "./ocrInput.vue?vue&type=style&index=0&id=0d866349&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d866349",
  null
  
)

export default component.exports